function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["addonsProps", "after", "afterProps", "before", "beforeProps", "children", "disabled", "error", "errorPosition", "errorProps", "helpText", "helpTextId", "helpTextProps", "hidden", "inlineAlertId", "labelPosition", "look"],
  _excluded2 = ["errorPosition", "labelPosition", "look"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../enums/accordion.js";
import "../../../enums/alert.js";
import "../../../enums/avatar.js";
import "../../../enums/breakpoints.js";
import "../../../enums/button.js";
import "../../../enums/code-editor.js";
import "../../../enums/colors.js";
import "../../../enums/combobox.js";
import "../../../enums/date.js";
import "../../../enums/drag-and-drop.js";
import "../../../enums/dialog.js";
import "../../../enums/divider.js";
import "../../../enums/dropdown.js";
import "../../../enums/fieldset.js";
import "../../../enums/font-icon.js";
import "../../../enums/fonts.js";
import "../../../enums/headings.js";
import { InputErrorPositions, InputLabelPositions, InputLooks } from "../../../enums/input.js";
import "../../../enums/keys.js";
import "../../../enums/list.js";
import "../../../enums/listbox.js";
import "../../../enums/loader.js";
import "../../../enums/margin.js";
import "../../../enums/option.js";
import "../../../enums/pill.js";
import "../../../enums/placements.js";
import "../../../enums/popout.js";
import "../../../enums/privacy.js";
import "../../../enums/radio-group.js";
import "../../../enums/status.js";
import "../../../enums/switch.js";
import "../../../enums/table.js";
import "../../../enums/tooltip.js";
import "../../../enums/transitions.js";
import "../../../enums/widths.js";
import "../../../themes/alert.js";
import "../../../themes/button.js";
import "../../../themes/checkbox.js";
import "../../../themes/divider.js";
import "../../../themes/dropdown.js";
import "../../../themes/fieldset.js";
import "../../../themes/input.js";
import "../../../themes/list.js";
import "../../../themes/listbox.js";
import "../../../themes/loader.js";
import "../../../themes/option.js";
import "../../../themes/popout.js";
import "../../../themes/switch.js";
import { lightTheme } from "../../../themes/themes.js";
import "../../../themes/tooltip.js";
import "../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import { InlineAlert } from "../../atoms/alert/inline-alert/inline-alert.js";
import "../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import "../../../styles/styled-components/alert.js";
import "../../../styles/styled-components/animations.js";
import "../../../styles/styled-components/box-shadow.js";
import "../../../styles/styled-components/button.js";
import "../../../styles/styled-components/font-face.js";
import "../../../styles/styled-components/global.js";
import "../../../styles/styled-components/input.js";
import "../../../styles/styled-components/list.js";
import "../../../styles/styled-components/listitem.js";
import "../../../styles/styled-components/media-queries.js";
import "../../../styles/styled-components/reset.js";
import "../../../styles/styled-components/outline.js";
import "../../../styles/styled-components/popout.js";
import "../../../styles/styled-components/screen-reader.js";
import "../../../styles/styled-components/switch.js";
import "../../../styles/styled-components/tooltip.js";
import "../../../utilities/color.js";
import 'date-fns';
import "../../../utilities/locale.js";
import '@brandfolder/utilities';
import "../../atoms/button/close-button/close-button.js";
import "../../atoms/button/color-button/color-button.js";
import "../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../atoms/button/icon-button/icon-button.js";
import "../../atoms/button/standard-button/standard-button.js";
import "../../atoms/loader/circle-loader/circle-loader.js";
import "../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../atoms/divider/standard-divider/standard-divider.js";
import "../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../atoms/heading/standard-heading/standard-heading.js";
import "../../atoms/label/standard-label/standard-label.js";
import "../../atoms/link/button-link/button-link.js";
import "../../atoms/link/standard-link/standard-link.js";
import "../../atoms/popout/standard-popout/standard-popout.js";
import "../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../atoms/table/standard-table/caption.js";
import "../../atoms/table/standard-table/tbody.js";
import "../../atoms/table/standard-table/tr-empty.js";
import "../../atoms/table/standard-table/td.js";
import "../../atoms/table/standard-table/tr.js";
import "../../atoms/table/standard-table/table.js";
import "../../atoms/table/standard-table/tfoot.js";
import "../../atoms/table/standard-table/th.js";
import "../../atoms/table/standard-table/thead.js";
import "../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../atoms/table/dnd-table/dnd-table-drag-context.js";
import { HelpText } from "../../atoms/text/help-text/help-text.js";
import "../../atoms/text/standard-text/standard-text.js";
import { TextfieldAddon, TextfieldAddonTypes } from "./textfield-addon.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseTextfieldBody = /*#__PURE__*/forwardRef(function (props, ref) {
  var addonsProps = props.addonsProps,
    after = props.after,
    afterProps = props.afterProps,
    before = props.before,
    beforeProps = props.beforeProps,
    children = props.children,
    disabled = props.disabled,
    error = props.error,
    errorPosition = props.errorPosition,
    errorProps = props.errorProps,
    helpText = props.helpText,
    helpTextId = props.helpTextId,
    helpTextProps = props.helpTextProps,
    hidden = props.hidden,
    inlineAlertId = props.inlineAlertId,
    labelPosition = props.labelPosition,
    look = props.look,
    otherProps = _objectWithoutProperties(props, _excluded);
  var hasAfter = !!after;
  var hasBefore = !!before;
  var hasError = !!error && !!inlineAlertId;
  var hasHelpText = !!helpText && !!helpTextId;
  var errorBottom = errorPosition === InputErrorPositions.Bottom;
  var errorTop = errorPosition === InputErrorPositions.Top;
  var labelTop = labelPosition === InputLabelPositions.Top;
  var showError = hasError && !hidden;
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: classnames(_defineProperty({
      'bf-textfield__body': true,
      'bf-textfield__body--after': hasAfter,
      'bf-textfield__body--before': hasBefore,
      'bf-textfield__body--disabled': disabled,
      'bf-textfield__body--error': hasError,
      'bf-textfield__body--error-bottom': errorBottom,
      'bf-textfield__body--error-top': errorTop,
      'bf-textfield__body--help-text': hasHelpText
    }, "".concat(otherProps === null || otherProps === void 0 ? void 0 : otherProps.className), !!(otherProps !== null && otherProps !== void 0 && otherProps.className))),
    ref: ref
  }), showError && errorTop && !labelTop && /*#__PURE__*/React.createElement(InlineAlert, _extends({}, errorProps, {
    id: inlineAlertId
  }), error), /*#__PURE__*/React.createElement("div", _extends({}, addonsProps, {
    className: classnames(_defineProperty({
      'bf-textfield__addons': true,
      'bf-textfield__addons--after': hasAfter,
      'bf-textfield__addons--before': hasBefore
    }, "".concat(addonsProps === null || addonsProps === void 0 ? void 0 : addonsProps.className), !!(addonsProps !== null && addonsProps !== void 0 && addonsProps.className)))
  }), hasBefore && /*#__PURE__*/React.createElement(TextfieldAddon, _extends({}, beforeProps, {
    disabled: disabled,
    error: error,
    look: look,
    type: TextfieldAddonTypes.Before
  }), before), children, hasAfter && /*#__PURE__*/React.createElement(TextfieldAddon, _extends({}, afterProps, {
    disabled: disabled,
    error: error,
    look: look,
    type: TextfieldAddonTypes.After
  }), after)), showError && errorBottom && /*#__PURE__*/React.createElement(InlineAlert, _extends({}, errorProps, {
    id: inlineAlertId
  }), error), hasHelpText && !hidden && /*#__PURE__*/React.createElement(HelpText, _extends({}, helpTextProps, {
    id: helpTextId
  }), helpText));
});
var Body = styled(BaseTextfieldBody)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  position: relative;\n\n  .bf-alert__inline {\n    margin-block-end: 5px;\n  }\n\n  &.bf-textfield__body--error-bottom {\n    .bf-alert__inline {\n      margin-block-end: 0;\n      margin-block-start: 5px;\n    }\n  }\n\n  .bf-text__help {\n    margin-block-start: 5px;\n  }\n\n  .bf-textfield__addons {\n    display: flex;\n  }\n"])));
var TextfieldBody = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$errorPosition = props.errorPosition,
    errorPosition = _props$errorPosition === void 0 ? InputErrorPositions.Top : _props$errorPosition,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Top : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Body, _extends({}, otherProps, {
    errorPosition: errorPosition,
    labelPosition: labelPosition,
    look: look,
    ref: ref
  })));
});
export { TextfieldBody };